<script>
  let list = [
    {
      source_name: 'user_03500_tik',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Julius_S_Malema',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'mervinramlukan',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Icasa',
      platform: 'press briefing',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'DZumaSambundla',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Nyuswapw',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Dudu Zuma-Sambudla',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Gentlements',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Laqhosha D.',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'RiotAndAttackSA',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'The Insight Factor',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'MandyNonkosi',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Mbuso Ngcobo',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'insightfactor',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Nyuswapw',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'UmzuluWaseNatal',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Jali Luthando',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ThaRealSeYda',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'PedzisaiRuhanya',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Marshall Security',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Free State Central News',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Dasen Thathiah',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Sphethile Mathenjwa',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Nivashni Nair',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'zola_hashatsi',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'SuperiorZulu',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Nivashni Nair',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Rob Beezy',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Sphithiphithi Evaluator',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Siphamandla Goge',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'mzansi_times',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Mngani_Phungula',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DZumaSambundla',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandDilemma',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'WokeMakoti',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Izwe Lethu',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'AdvoBarryRoux',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'AdvoBarryRoux',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'FreeNxamalala',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'FreeNxamalala',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kzngov',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Sandraboyce19',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'IndWorldThinker',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'BabaKaNkanyezi',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Hopewell Chin’ono Today',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'AMGLOUNGE_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SiphamandlaGoge',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'DrKevinGrantsa',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'DuduzaneZuma_',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Hopewell Chin’ono Today',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Mavhure',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'nomfundo_ndabezinhle\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'mr_l_mbambo',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'planetsouthafrica',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'slungile94_cele\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'mzansishakers',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'cartracker\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'sihleshezi48',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'cartracker\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Jayed-Leigh Paulse',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'GMR FM',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'eri_abrahams',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'AdvoBarryRoux',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'FreeNxamalala',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Jayed-Leigh Paulse',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'N3 Toll Concession',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SiphamandlaGoge',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'insightfactor',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'GMR FM',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Mfundoyakhe_S',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Jayed-Leigh Paulse',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Duduzane__Zuma',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SBzo69',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Bayabonga6',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SS_Mogashoa',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Thabani Mdletshe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_ArriveAlive',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'NShezi',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Dasen Thathiah',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'FreeNxamalala',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'BOSBEER.COM',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'insightfactor',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ThabisoSithole',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'saadsajjad007',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'liquidher0',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'saadsajjad007',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'anelepercy\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'anelepercy\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'mbalingunezi',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'vukosivkaiakporsb',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'goldcenturylogistics',
      platform: 'media',
      media_house: 'no',
    },
    {
      source_name: 'TmanThaban',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LuyaBrownie',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Abramjee',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'fscentralnews',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'TrafficSA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'JoburgMPD',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'insightfactor',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'sportsSA4',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'IndWorldThinker',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'BlackandProud8',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'BlackandProud8',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'rinmor',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'rtcsa1',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'RealTebz',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'MokupiPogisho',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SABCNews',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'RealTebz',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'RealTebz',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Simon_Moetjie',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Abramjee',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'vico_dbn',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'MagatePhala1',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'NickolausBauer',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Taboooo251',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'The Witness',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Economic_Rebel',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Economic_Rebel',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'sphescooby',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'NickolausBauer',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'JayedLeigh',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'PhiweMkhuzo',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'Nabeelah_Shaikh',
      media_house: 'Twitter',
    },
    {
      source_name: 'NickolausBauer',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'FreeNxamalala',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Gentlements',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'janetvaneeden',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LandNoli',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'NickolausBauer',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'metrorailgp',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'saadsajjad007',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'joeemiliocomedian',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'joeemiliocomedian',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'elite.battalion\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'zee2khumalo',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'dalton_paris',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'nkullekom',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'londie_pyt',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'siipphhoo0\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'siipphhoo0\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'saadsajjad007',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'sbutubutumahlongwa\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'zothani.ngidi',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'nkullekom',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'mercy_gjee\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'saadsajjad007',
      media_house: 'TikTok',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Business News',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SCP_SECURITY',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'SCN_Nkosi',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'mwelimasilela',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'PatrolPark',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'eNCAnews',
      platform: 'Facebook',
      media_house: 'yes',
    },
    {
      source_name: 'JayPlay89610572',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'mlumthembu',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'misssabera',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Abramjee',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'News 24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Arrowhead Properties',
      platform: 'Sens Report',
      media_house: 'no',
    },
    {
      source_name: 'GroundUp',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'City Press',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'South Coast Herald',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'TyraQeed',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'thanda7',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'SB_Vilakazi',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'HermaineM',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'PineWalkCentre',
      platform: 'Facebook',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'no',
    },
    {
      source_name: 'News23',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'als2010',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Mail and Guardian',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'LukhanyoSupKid',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'VehicleTrackerz',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'City Press',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Benoni City Times',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Mpumalanga News',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'DasenThathiah',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'RomanCabanac',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'JustNathanCraig',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Ndiks17',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Zululand Observer',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Alberton Record',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'iol',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Nabeelah_Shaikh',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'DasenThathiah',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Mluh_N',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'swazikush',
      platform: 'twitter',
      media_house: 'no',
    },
    {
      source_name: 'lucky_lekgwathi14',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'kea1478',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ynews',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Puleng_pg',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'GogoRhapu',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'bashini_naicker',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Nonku_Radebe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ECR_Newswatch',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Sowetan',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Fourways Review',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'ECR_Newswatch',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'SiphamandlaGoge',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_AfricanSoil',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'KendriQBulelanI',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'GogoRhapu',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Springs Advertiser',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Springs Advertiser',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'iol',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'iol',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'PigSpotter',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Zululand Observer',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'joeemiliocomedian',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'kervalster\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'hallebberry',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'katsuleman',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'medusa_za',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'mrsmorgs2109',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'medusa_za',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'leko_radebe',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'nelly1nell\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'whoisgagashe',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'medusa_za',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'kervalster',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'whoisgagashe',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'oloricody_\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'anelepercy\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'sssfinditfastsa\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'kervalster\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'katlegosuccesspul',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'shakira_maps',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'siipphhoo0\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'escalatemarsh',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'papipengting',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'dalton_paris',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'lt_mogale_despeaker\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'venommansa',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'ZazmoneyDJ',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'OFM',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'bbb5370746a0438',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'TheunsJonck',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Waseem_Moola',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LeahJazzLive',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Suitcaseboy',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'KierranAllenPhotography',
      platform: 'Facebook',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'EWN',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'sikelela321',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Reuters',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'shakazuluburner',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'FreeNxamalala',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'IDesai23',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'eri_abrahams',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Motheo090909',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'RianteP',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'SpotOnLee',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'crimewatch202',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ECR_Newswatch',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ECR_Newswatch',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'RONALDMASINDA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_MuzieB',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'dexteraps',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'peter_matsvai',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'IDesai23',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'wandilemtambo\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'yoshezzy',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'fitmomcas',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'joeemiliocomedian',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'leothegr8est\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'katlegosuccesspul',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'jakejohn.21',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'GiftAkefe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'diamond4052',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kedibonesa',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'The Witness',
      platform: 'YouTube',
      media_house: 'yes',
    },
    {
      source_name: 'Bhekisisa',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'GiftAkefe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ecr9495',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'wicks_jeff',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ewnreporter',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'RONALDMASINDA',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_ArriveAlive',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'East Coast Radio',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'ndi_shony',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ndi_shony',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'ECR_Newswatch',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'ECR_Newswatch',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'East Coast Radio',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'tourist_ms',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'GiftAkefe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'SANDF_ZA',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'AfcJimboz',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'AfcJimboz',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Idomusik',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'kiolee_panday',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'lejeay_storm\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'rayjab0\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'paigeluxke\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'dewazer',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'nikki_unix25\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'kznshutdownupdates',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'Yourmadwolf',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'GiftAkefe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'majola_buse',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'PalesaDlamini_0',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'KatSekhotho',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'PalesaDlamini_0',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'wicks_jeff',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: '_DJMosh',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'wicks_jeff',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'spheshs',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'PalesaDlamini_0',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'PalesaDlamini_0',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'PalesaDlamini_0',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'PalesaDlamini_0',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'VusiSambo',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'noksy_k',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: '_PhilaK',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'wicks_jeff',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Newzroom405',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'Cape Talk',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'dieduikboot',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'avinai_maharaj04',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'imranjutt778\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'GiftAkefe',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'marshall_security',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: '\nnikki_unix25\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'kulanicool',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'City_Press',
      platform: 'Twitter',
      media_house: 'yes',
    },
    {
      source_name: 'sebecks',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'Cape Talk',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'fitmomcas\n\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'kingofjerusalem',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'yuraishapillay',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'sandisonxumalo',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'vw_airsuv\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'CyrilRamaphosa',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'hello_durban',
      platform: 'Instagram',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'News24',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'joshwideawake',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'ramzi__singh12',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'media',
      media_house: 'yes',
    },
    {
      source_name: 'djjazzyd\n',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: 'melissa_mbatha',
      platform: 'TikTok',
      media_house: 'no',
    },
    {
      source_name: '',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'BrightsonSA',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'LekwaloMaraks',
      platform: 'Twitter',
      media_house: 'no',
    },
    {
      source_name: 'sk_nuf',
      platform: 'Twitter',
      media_house: 'no',
    },
  ]

  let list2 = list.filter((f) => f.platform === 'Twitter')
  let unique = [...new Set(list2.map((x) => x.source_name))]
  console.log(unique)
</script>

<div>
  {#each unique as l}
    <div>{l}</div>
  {/each}
</div>
